// Libs
import _isEmpty from 'lodash/isEmpty'
import sort from 'fc-seasons/src/utils/sort'
import traverse from 'fc-utils/traverse'

// Constants
import {
  SELECT_SEASON,
} from '../constants'
import {
  PROP_HEFTY_SELECTED_SEASON,
} from 'fc-model-environment/src/constants'


// Actions
import { filterJobsBySeason, FILTER_BY_SEASON } from 'hfty-soil-jobs'

// Controller
import environmentCtrl from 'fc-ctrl-environment'
import seasonsCtrl from 'fc-ctrl-seasons'

// Effect Managers
import { call, select, take, race, put } from 'redux-saga/effects'

// Selectors
import { authenticatedUser$ } from 'fc-users'
import { environment$ } from 'fc-environment'
import { sortedSeasons$ } from 'fc-seasons'

const selectedSeasonId$ = traverse(['mapModule', 'selectedSeasonId'])

export default function *watchUpdateSeason (): Generator<*, *, *> {
  while (true) {
    const {mapSelectorUpdate, jobFilterUpdate} = yield race({
      mapSelectorUpdate: take(SELECT_SEASON),
      jobFilterUpdate: take(FILTER_BY_SEASON),
    })

    const authenticatedUser = yield select(authenticatedUser$)
    const environment = yield select(environment$)

    let {payload} = mapSelectorUpdate || jobFilterUpdate
    const seasonId = yield call(validateSeason, payload)

    if (environment[PROP_HEFTY_SELECTED_SEASON]) {
      const shouldUpdate = Number(environment[PROP_HEFTY_SELECTED_SEASON].value) !== seasonId
      if (shouldUpdate) {
        yield call(environmentCtrl.update, {
          model: {
            client: authenticatedUser,
            key: PROP_HEFTY_SELECTED_SEASON,
            id: environment[PROP_HEFTY_SELECTED_SEASON].id,
            value: seasonId,
          },
        })
      }
    } else {
      yield call(environmentCtrl.create, {
        model: {
          client: authenticatedUser,
          key: PROP_HEFTY_SELECTED_SEASON,
          value: seasonId,
        },
      })
    }
    if (mapSelectorUpdate) {
      // Update season filter on jobs page
      yield put(filterJobsBySeason(seasonId))
    }
  }
}

function *validateSeason (payload) {
  // Set latest season as default if none was set on env
  if (!payload || payload === '') {
    const mapModuleSeason = yield select(selectedSeasonId$)
    if (_isEmpty(mapModuleSeason)) {
      let seasons = yield select(sortedSeasons$)
      if (_isEmpty(seasons)) {
        const { payload: { data } } = yield take(seasonsCtrl.actionTypes.receive())
        seasons = sort(data)
      }
      return seasons[0].id
    } else return mapModuleSeason
  } else return payload
}
